import { Button, Input, InputPassword, Space, Text } from '@billy/design-system'
import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { SubmitLoginResponseData } from '../../../../query-api/login-query'
import { useLoginForm } from './hooks/useLoginForm'

interface LoginFormProps {
  invitationEmail: string
  title: string
  onSuccess?: (response: SubmitLoginResponseData) => void
}

export const LoginForm = ({ invitationEmail, title, onSuccess }: LoginFormProps): ReactElement => {
  const { t } = useTranslation()
  const { Form, FormItem, submitForm, isLoading } = useLoginForm({
    invitationEmail,
    onSuccess,
  })

  return (
    <>
      <Text variant="h1">{title}</Text>
      <Space size="s24" />
      <Text variant="h4">{t('organization_invitation.form.login_sub_title')}</Text>
      <Space size="s24" />
      <Form>
        <FormItem
          label={t('organization_invitation.form.label.email')}
          name="email"
          render={({ field }) => (
            <Input
              {...field}
              disabled={!!invitationEmail}
              placeholder={t('organization_invitation.form.placeholder.email')}
              size="lg"
            />
          )}
        />
        <Space />
        <FormItem
          label={t('organization_invitation.form.label.password')}
          name="password"
          render={({ field }) => (
            <InputPassword {...field} placeholder={t('organization_invitation.form.placeholder.password')} size="lg" />
          )}
        />
        <Space size="s24" />
        <Button type="submit" size="lg" fullWidth onClick={submitForm} loading={isLoading}>
          {t('organization_invitation.form.accept_invitation')}
        </Button>
      </Form>
    </>
  )
}
